/**
 * Currency symbols configuration
 * Maps ISO currency codes to their display symbols
 */

export const currencySymbols: Record<string, string> = {
    // Major currencies
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CHF: "CHF",

    // Dollar currencies
    CAD: "$",
    AUD: "$",
    NZD: "$",
    HKD: "$",
    SGD: "$",
    MXN: "$",
    BRL: "R$",
    ARS: "$",
    CLP: "$",
    COP: "$",

    // Asian currencies
    CNY: "¥",
    KRW: "₩",
    INR: "₹",
    THB: "฿",
    IDR: "Rp",
    MYR: "RM",
    PHP: "₱",
    VND: "₫",

    // European currencies
    SEK: "kr",
    NOK: "kr",
    DKK: "kr",
    CZK: "Kč",
    PLN: "zł",
    HUF: "Ft",
    RON: "lei",
    BGN: "лв",
    HRK: "kn",
    RUB: "₽",
    TRY: "₺",

    // Middle Eastern & African currencies
    AED: "د.إ",
    SAR: "﷼",
    ILS: "₪",
    ZAR: "R",
    EGP: "E£",

    // Other currencies
    CRC: "₡",
    ISK: "kr",
};

/**
 * Get the currency symbol for a given currency code
 * Falls back to the currency code itself if no symbol is found
 */
export const getCurrencySymbolFromMap = (currencyCode: string): string => {
    return currencySymbols[currencyCode.toUpperCase()] || currencyCode;
};
